var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cargo-button-group-slider" }, [
    _c(
      "div",
      {
        staticClass: "wrapper",
        class: [_vm.isScrollable ? "is-scrollable" : ""]
      },
      [
        _vm.isScrollable
          ? _c("span", { staticClass: "pre", on: { click: _vm.handlePre } }, [
              _c("i", { staticClass: "el-icon-caret-left" })
            ])
          : _vm._e(),
        _vm.isScrollable
          ? _c("span", { staticClass: "next", on: { click: _vm.handleNext } }, [
              _c("i", { staticClass: "el-icon-caret-right" })
            ])
          : _vm._e(),
        _c(
          "div",
          {
            ref: "scroller",
            staticClass: "scroller",
            style: !_vm.isScrollable ? "text-align:" + _vm.align : ""
          },
          [
            _c(
              "div",
              {
                ref: "btn-group",
                staticClass: "button-group",
                style: "left:" + _vm.offsetWidth + "px"
              },
              [_vm._t("default")],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }